import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { FinalCta } from './components/FinalCta';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="28u5z6q8t7bef">
      <MetaPixel data-id="element-1" data-mp="28t4k8aooa4rf" />
      <CountdownBar data-id="element-2" data-mp="28sl5t3y8dyi5" />
      <main data-id="element-3" data-mp="23vciyq2516ak">
        <Hero data-id="element-4" data-mp="23vkuoemiy5k6" />
        <StatsBar data-id="element-5" data-mp="23w4gi6fape3h" />
        <Difference data-id="element-6" data-mp="23ujjma5idj2g" />
        <Recognize data-id="element-7" data-mp="23v2tr4ox335x" />
        <WhatsInside data-id="element-8" data-mp="23ti5txx3yih1" />
        <InsidePages data-id="element-9" data-mp="3ikh7o8icgqyg" />
        <Bonuses data-id="element-10" data-mp="3iiwfuqnezm4a" />
        <Offer data-id="element-11" data-mp="3ijfu9xduvsdk" />
        <Guarantee data-id="element-12" data-mp="3ihv048vgebg8" />
        <Testimonials data-id="element-13" data-mp="3mlj98vzqhf3l" />
        <Faq data-id="element-14" data-mp="3mkrdnl64zhdb" />
        <FinalCta data-id="element-15" data-mp="3mkhnnxl3da7m" />
      </main>
      <Footer data-id="element-16" data-mp="3mjg9vlcoy9m7" />
    </div>;
}